import { PaymentIcon } from "../../Assets/svgs/PaymentIcon";
import { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { UsFlag } from "../../Assets/svgs/UsFlag";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  ElementsConsumer,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { SuccessModel } from "../../Model/SuccessModel";
import { useDispatch } from "react-redux";
import { paymentIntent } from "../../Redux/Slice/Common/PaymentSlice";
import { ErrorModel } from "../../Model/ErrorModel";
import { nameValidation } from "../../Common/Validations";
import { Loader } from "../../Common/Loader";
import { changePlan } from "../../Redux/Slice/Plans/ChangePlanSlice";
import { saveCurrentUserData } from "../../Redux/Slice/Common/CurrentUserSlice";
import { TERMS_AND_CONDITIONS_URL } from "../../Common/Constants";
import axiosInstance from "../../Service/Interceptor";
import { STRIPE_KEYS } from "../../Config";
import { getPaymentMethodList } from "../../Redux/Slice/PaymentMethod/GetPaymentMethodListSlice";
import moment from "moment";
import { getCountCreditAvailable } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCountCreditAvailableSlice";

export const PaymentComponent = (props) => {
  const elementRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const stripe = useStripe();
  const isTopUpPlan = props?.isTopUpPlan || false;
  const isFromDashBoard = props?.isFromDashBoard || false;
  const isFromBuyAdditionalAssistant = props?.isAdditionalAssistant || false;
  const elements = useElements();
  const [stripeError, setStripeError] = useState(null);
  const [secret, setSecret] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [plan, setPlan] = useState({
    price: 0,
    numberOfCredits: 0,
    interval: "month",
  });
  const [additionalAssistantData, setAdditionalAssistantData] = useState({
    noOfAssistant: 0,
    maxNoOfAssistant: 0,
    perAssistantPrice: 0,
  });
  const [additionalAssistantDataError, setAdditionalAssistantDataError] =
    useState({
      noOfAssistant: "",
    });
  const [cardList, setCardList] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("ADD_NEW_CARD"); // ADD_NEW_CARD, payment_method_id
  const [credits, setCredits] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [billedTo, setBilledTo] = useState("");
  const [nameError, setNameError] = useState("");
  const userData = JSON.parse(localStorage.getItem("userData"));

  const paymentSuccess = () => {
    setSuccessMessage("Plan Changed Succesfully");
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      navigate("/subscription");
    }, 2000);
  };

  const handelNamechange = (e) => {
    let value = e?.target?.value;
    const isValid = nameValidation(value);
    if (isValid || value.trim() === "") {
      setNameError("");
    } else {
      setNameError("Please enter valid name");
    }
    let capitalized = value.charAt(0).toString().toUpperCase();
    value = capitalized + value.substring(1);
    setBilledTo(value);
  };

  const onSuccessPlanChanged = async () => {
    await dispatch(getCountCreditAvailable());
    setLoading(false);
    if (isFromBuyAdditionalAssistant) {
      setSuccessMessage("Assistant limit increased Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate("/assistants");
      }, 1500);
      return;
    } else if (isTopUpPlan) {
      setSuccessMessage("TopUp Plan Added Successfully!");
    } else {
      let userData = JSON.parse(localStorage.getItem("userData"));
      userData.customer.isPaymentMethodAdded = true;
      if (location?.state?.plan) {
        userData.customer.plan = location.state.plan;
      }
      localStorage.setItem("userData", JSON.stringify(userData));
      dispatch(saveCurrentUserData(userData));
      setSuccessMessage("Plan Changed Successfully!");
    }
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      navigate("/subscription");
    }, 1500);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    let paymentMethodId;
    if (
      !isFromBuyAdditionalAssistant ||
      (isFromBuyAdditionalAssistant && selectedPaymentMethod == "ADD_NEW_CARD")
    ) {
      const cardElement = props.elements.getElement(CardNumberElement); // Create a payment method
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });
      if (error) {
        setLoading(false);
        setErrorMessage(error.message ? error.message : "Invalid Card details");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
        return;
      }
      paymentMethodId = paymentMethod.id;
    } else if (isFromBuyAdditionalAssistant && selectedPaymentMethod) {
      paymentMethodId = selectedPaymentMethod;
    }

    let userData = JSON.parse(localStorage.getItem("userData"));
    if (userData.customer) {
      const plan = location?.state?.plan
        ? location.state.plan.id
        : userData?.customer?.plan != null
        ? userData?.customer?.plan?.id
        : "";
      let planData = {
        customerId: userData?.customer?.id,
        stripePaymentMethodId: paymentMethodId,
        stripeCustomerId: userData?.customer?.stripeCustomerId,
        planId: plan,
      };
      if (isFromBuyAdditionalAssistant) {
        planData.amount =
          Number(additionalAssistantData.perAssistantPrice) *
          Number(additionalAssistantData.noOfAssistant);
        planData.noOfBuyAssistants = Number(
          additionalAssistantData.noOfAssistant
        );
      }
      try {
        const response = await axiosInstance.post(
          isFromBuyAdditionalAssistant
            ? "customer/buy-assistant"
            : isTopUpPlan
            ? "customer/buy-topup-plan"
            : "customer/change-plan",
          planData
        );
        const result = response?.data;
        if (result?.success === true) {
         await onSuccessPlanChanged();
        } else {
          setLoading(false);
          setErrorMessage(result?.error?.message);
          setErrorModel(true);
          setTimeout(() => {
            setErrorModel(false);
          }, 1500);
        }
      } catch (error) {
        if (error?.message?.data?.type === "3D_SECURE_REQUIRED") {
          try {
            // Handle the 3D Secure authentication
            const { paymentIntentId, clientSecret } = error?.message.data;
            const stripe = await loadStripe(STRIPE_KEYS.STRIPE_PUBLISHABLE_KEY);
            const result = await stripe.confirmCardPayment(clientSecret);

            if (result.error) {
              setLoading(false);
              setErrorMessage(result.error.message);
              setErrorModel(true);
              setTimeout(() => {
                setErrorModel(false);
              }, 1500);
              return {
                success: false,
                message: result.error.message,
              };
            }

            let paymentBody = {
              paymentIntentId: paymentIntentId,
              planId: planData.planId,
              customerId: planData.customerId,
              isTopupPayment: isTopUpPlan,
              isAdditionalAssistant: isFromBuyAdditionalAssistant,
            };
            if (isFromBuyAdditionalAssistant) {
              paymentBody.amount =
                Number(additionalAssistantData.perAssistantPrice) *
                Number(additionalAssistantData.noOfAssistant);
              paymentBody.noOfBuyAssistants = Number(
                additionalAssistantData.noOfAssistant
              );
            }
            // After successful 3D Secure authentication, confirm the payment
            const confirmationResponse = await axiosInstance.post(
              "customer/confirm-3d-secure",
              paymentBody
            );

            await onSuccessPlanChanged();
            return confirmationResponse.data;
          } catch (confirmError) {
            setLoading(false);
            setErrorMessage(
              confirmError.message || "Payment authentication failed"
            );
            setErrorModel(true);
            setTimeout(() => {
              setErrorModel(false);
            }, 1500);

            return {
              success: false,
              message: confirmError.message || "Payment authentication failed",
            };
          }
        }
        setLoading(false);
        setErrorMessage("Payment authentication failed");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);

        return {
          success: false,
          message: "Payment authentication failed",
        };
      }
    } else {
      setLoading(false);
      setErrorMessage("Invalid User Details");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const handleChangeNoOfAssistant = (e) => {
    const { value } = e?.target;
    const planPrice = parseInt(value) >= 0 ? value : "";
    setAdditionalAssistantData((prev) => ({
      ...prev,
      noOfAssistant: planPrice,
    }));
    setAdditionalAssistantDataError((prev) => ({
      noOfAssistant:
        planPrice && planPrice > additionalAssistantData.maxNoOfAssistant
          ? `You can add up to ${additionalAssistantData.maxNoOfAssistant} assistants only.`
          : "",
    }));
  };

  const getCardList = async () => {
    setLoading(true);
    try {
      const result = await dispatch(
        getPaymentMethodList({ searchText: "", page: 1, limit: 200 })
      );
      if (
        getPaymentMethodList.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        const data = Array.isArray(result?.payload.data)
          ? result.payload.data.map((item) => {
              return {
                ...item,
                maskedCardNumber: `****-****-****-${item?.last4 ?? ""}`,
                cardExpiryDate: `${item?.expMonth}/${moment(
                  item?.expYear,
                  "YYYY"
                ).format("YY")}`,
              };
            })
          : [];
        const defaultPaymentMethod = data?.find((card) => card.isDefault);
        setCardList(data);
        setSelectedPaymentMethod(
          defaultPaymentMethod?.stripePaymentMethodId || "ADD_NEW_CARD"
        );
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setBilledTo(`${userData.firstName} ${userData?.lastName}`);
    if (isFromBuyAdditionalAssistant) {
      setAdditionalAssistantData((prev) => ({
        ...prev,
        noOfAssistant: 0,
        maxNoOfAssistant: location?.state?.maxAssistant || 0,
        perAssistantPrice: location?.state?.assistantAmount || 0,
      }));
      getCardList();
    } else if (location.state?.plan) {
      setPlan(location.state?.plan);
    } else if (userData.customer?.plan) {
      setPlan(userData.customer.plan);
    }
  }, [isFromBuyAdditionalAssistant, location?.state]);

  useEffect(() => {
    if (location.search) {
      if (location.search.endsWith("succeeded")) {
        paymentSuccess();
      }
    }
  }, [location]);

  if (stripeError) {
    return;
  }

  return (
    <div className="page__body">
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      <div
        className={
          isFromBuyAdditionalAssistant
            ? "paymentWrap paymentWrap--buyAssistants"
            : isFromDashBoard
            ? "paymentWrap paymentWrap--dashboard"
            : "paymentWrap"
        }
      >
        <form className="paymentWrap__form">
          <div className="paymentWrap__item">
            <div className="paymentWrap__header">
              <h1 className="title title--h3">
                {isFromBuyAdditionalAssistant
                  ? "Buy Additional Assistants"
                  : isTopUpPlan
                  ? "Buy Additional Credit"
                  : "Start a premium plan with us today"}
              </h1>
              {/* <p className="para">
                Get all access and an extra 20% off when you subscribe annually
              </p> */}
            </div>

            <div className="paymentWrap__body">
              <div className="form__group">
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__group">
                      <label className="form__label">Billed to</label>
                      <div className="form__groupField">
                        <input
                          type="text"
                          className="form__input"
                          placeholder="Enter your name"
                          value={billedTo}
                          onChange={handelNamechange}
                        />
                      </div>
                    </div>
                    <div className="form__error">{nameError}</div>
                  </div>
                </div>
              </div>
              {isFromBuyAdditionalAssistant && cardList.length ? (
                <>
                  <div className="form__group">
                    <label className="form__label form__label--black">
                      Select Card For Payment
                    </label>
                    <div className="tableWrap p_0">
                      <div className="tableContainer">
                        <table className="table">
                          <tbody>
                            {cardList?.map((card) => (
                              <tr>
                                <td>
                                  <div className="form__radio form__radio--gray">
                                    <div className="form__radio__option mb_0">
                                      <input
                                        type="radio"
                                        id={`checkbox-card-${card?.id}`}
                                        checked={
                                          selectedPaymentMethod ==
                                          card?.stripePaymentMethodId
                                        }
                                        onChange={() => {
                                          setSelectedPaymentMethod(
                                            card?.stripePaymentMethodId
                                          );
                                        }}
                                        className="form__radio__input"
                                      />
                                      <label
                                        className="form__radio__label"
                                        for={`checkbox-card-${card?.id}`}
                                      >
                                        &nbsp;
                                      </label>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="cellText">
                                    <span className="cellText__dark">
                                      {card?.maskedCardNumber}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div className="cellText">
                                    <span className="cellText__dark">
                                      {card?.brand}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div className="cellText">
                                    <span className="cellText__dark">
                                      {card?.cardExpiryDate}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="form__group">
                    <div className="formDivider">
                      <span>Or</span>
                    </div>
                  </div>
                </>
              ) : null}
              <div className="form__group">
                {isFromBuyAdditionalAssistant && cardList.length ? (
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__group">
                        <div className="form__radio">
                          <div className="form__radio__option">
                            <input
                              type="radio"
                              id="AddNewCard"
                              className="form__radio__input"
                              checked={selectedPaymentMethod == "ADD_NEW_CARD"}
                              onChange={() => {
                                setSelectedPaymentMethod("ADD_NEW_CARD");
                              }}
                            />
                            <label
                              className="form__radio__label"
                              for="AddNewCard"
                            >
                              Add New Card
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__group">
                      <label className="form__label">Card Number</label>
                      <div className="form__groupField">
                        <CardNumberElement className="form__input" />
                        <div className="icon">
                          <svg
                            width="86"
                            height="22"
                            viewBox="0 0 86 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="0.559435"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              fill="white"
                            ></rect>
                            <rect
                              x="0.559435"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              stroke="#C5CDD0"
                              stroke-width="0.900609"
                            ></rect>
                            <path
                              d="M20.4277 8.22494L21.5522 13.5934H20.2639C20.2124 13.3687 20.1721 13.1337 20.1206 12.909C20.0691 12.6842 20.1206 12.7966 19.9877 12.7966H18.424C18.4072 12.7937 18.3899 12.7943 18.3734 12.7985C18.3568 12.8026 18.3412 12.8102 18.3278 12.8207C18.3143 12.8312 18.3031 12.8444 18.295 12.8594C18.287 12.8745 18.2821 12.8911 18.2808 12.9081C18.2087 13.114 18.1376 13.3181 18.0561 13.5119C17.9737 13.7058 17.984 13.6037 17.9531 13.6037H16.5739V13.4811C17.255 11.866 17.9369 10.2475 18.6179 8.6255C18.6582 8.5154 18.7302 8.41972 18.8248 8.35056C18.9195 8.2814 19.0325 8.24186 19.1497 8.23695C19.5991 8.21636 20.0083 8.22666 20.4277 8.22666M19.467 9.73024L18.7405 11.6833H19.8856L19.467 9.73024ZM7.92466 11.8754V11.7528C8.33379 10.618 8.75236 9.48322 9.1512 8.34845C9.1512 8.25668 9.23354 8.21551 9.33561 8.21551H10.6951V8.34845L8.5791 13.4605C8.56905 13.5029 8.54348 13.5399 8.50744 13.5644C8.47139 13.5888 8.42749 13.5989 8.3844 13.5926H7.19903C7.0961 13.5926 7.05579 13.5926 7.02491 13.4596C6.64751 11.9878 6.2581 10.5159 5.87985 9.03377C5.8709 8.99581 5.85455 8.95998 5.83173 8.92833C5.80892 8.89669 5.78009 8.86986 5.7469 8.84936C5.35217 8.62972 4.93416 8.45481 4.50063 8.32787C4.50063 8.32787 4.42858 8.27641 4.39771 8.25668C4.44141 8.24625 4.48695 8.24625 4.53065 8.25668H6.57546C6.66087 8.24369 6.74806 8.24889 6.83131 8.27194C6.91457 8.29499 6.99202 8.33537 7.05858 8.39044C7.12514 8.4455 7.17932 8.51401 7.21757 8.59147C7.25581 8.66893 7.27726 8.7536 7.28051 8.83993L7.86376 11.8342C7.86037 11.8581 7.86037 11.8824 7.86376 11.9063L7.92466 11.8754ZM12.6884 13.3884L12.8934 12.1919L13.0367 12.2742C13.5586 12.5446 14.1575 12.6276 14.7333 12.5093C14.8433 12.4998 14.9477 12.4564 15.032 12.3849C15.1162 12.3134 15.1761 12.2175 15.2033 12.1104C15.2137 12.0037 15.1896 11.8964 15.1345 11.8043C15.0793 11.7123 14.9961 11.6404 14.8971 11.5992C14.6921 11.4663 14.4682 11.3642 14.2735 11.2313C14.0217 11.0903 13.7883 10.9185 13.5788 10.7201C13.3666 10.4662 13.2504 10.146 13.2504 9.81516C13.2504 9.48436 13.3666 9.16407 13.5788 8.91026C13.8865 8.57383 14.289 8.33874 14.7333 8.23609C15.41 8.06718 16.1216 8.1027 16.7781 8.33816H16.8295L16.6348 9.44205C16.3769 9.36267 16.1138 9.30134 15.8474 9.2585C15.5819 9.23807 15.3153 9.23807 15.0498 9.2585C14.9539 9.27755 14.8655 9.32368 14.795 9.39144C14.7609 9.42035 14.7334 9.45635 14.7146 9.49694C14.6958 9.53752 14.686 9.58172 14.686 9.62646C14.686 9.6712 14.6958 9.7154 14.7146 9.75598C14.7334 9.79657 14.7609 9.83257 14.795 9.86148C14.9171 9.97388 15.0504 10.0733 15.193 10.1582C15.4589 10.3212 15.7351 10.4542 15.9907 10.6283C16.2021 10.7575 16.3775 10.9381 16.5005 11.1533C16.6235 11.3684 16.6901 11.6112 16.6942 11.8589C16.6983 12.1067 16.6397 12.3515 16.524 12.5706C16.4082 12.7897 16.2389 12.976 16.0318 13.1122C15.6242 13.4279 15.1345 13.6196 14.6209 13.6646C13.9638 13.7372 13.299 13.6422 12.6884 13.3884ZM10.4189 13.5926L11.2981 8.2258H12.6987L11.8196 13.5926H10.4189Z"
                              fill="#1B2E86"
                            ></path>
                            <rect
                              x="30.151"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              fill="white"
                            ></rect>
                            <rect
                              x="30.151"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              stroke="#C5CDD0"
                              stroke-width="0.900609"
                            ></rect>
                            <g clip-path="url(#clip0_1_20701)">
                              <path
                                d="M40.2646 6.34302H45.13V15.3351H40.2646V6.34302Z"
                                fill="#FF5F00"
                              ></path>
                              <path
                                d="M40.5746 10.8404C40.5746 9.01346 41.4086 7.39294 42.6906 6.34437C41.7485 5.5818 40.5592 5.12109 39.2617 5.12109C36.1879 5.12109 33.7012 7.67888 33.7012 10.8404C33.7012 14.0019 36.1879 16.5598 39.2617 16.5598C40.5591 16.5598 41.7484 16.0991 42.6906 15.3365C41.4086 14.3038 40.5746 12.6674 40.5746 10.8404Z"
                                fill="#EB001B"
                              ></path>
                              <path
                                d="M51.695 10.8404C51.695 14.0019 49.2082 16.5598 46.1345 16.5598C44.8371 16.5598 43.6478 16.0991 42.7056 15.3365C44.003 14.288 44.8216 12.6674 44.8216 10.8404C44.8216 9.01346 43.9875 7.39294 42.7056 6.34437C43.6477 5.5818 44.8371 5.12109 46.1345 5.12109C49.2082 5.12109 51.695 7.6948 51.695 10.8404Z"
                                fill="#F79E1B"
                              ></path>
                            </g>
                            <rect
                              x="59.7423"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              fill="white"
                            ></rect>
                            <rect
                              x="59.7423"
                              y="1.06725"
                              width="24.8311"
                              height="19.6847"
                              rx="2.12286"
                              stroke="#C5CDD0"
                              stroke-width="0.900609"
                            ></rect>
                            <g clip-path="url(#clip1_1_20701)">
                              <path
                                d="M75.8821 6.12293C75.3219 5.44633 74.3092 5.15625 73.0136 5.15625H69.2536C69.1254 5.15626 69.0014 5.20471 68.9039 5.29291C68.8065 5.3811 68.7419 5.50325 68.7218 5.6374L67.1562 16.1587C67.125 16.3662 67.2767 16.5541 67.4751 16.5541H69.7964L70.3794 12.6359L70.3613 12.7586C70.4029 12.4816 70.6264 12.2774 70.8911 12.2774H71.9942C74.1612 12.2774 75.858 11.3447 76.3537 8.64677C76.3684 8.56697 76.3811 8.48931 76.3921 8.41344C76.3296 8.37833 76.3296 8.37833 76.3921 8.41344C76.5397 7.41625 76.3911 6.73747 75.8821 6.12293Z"
                                fill="#27346A"
                              ></path>
                              <path
                                d="M71.2676 8.05422C71.3311 8.0222 71.4005 8.0056 71.4708 8.00565H74.4186C74.7677 8.00565 75.0933 8.02972 75.3908 8.08046C75.474 8.09452 75.5569 8.11132 75.6391 8.13081C75.7557 8.15808 75.871 8.19145 75.9845 8.2308C76.1308 8.28256 76.267 8.34284 76.3922 8.41344C76.5397 7.41587 76.3911 6.73747 75.8821 6.12293C75.3215 5.44633 74.3092 5.15625 73.0136 5.15625H69.2533C68.9885 5.15625 68.7633 5.36048 68.7218 5.6374L67.1562 16.1583C67.125 16.3661 67.2767 16.5538 67.4748 16.5538H69.7964L71.0059 8.42656C71.0178 8.34667 71.0479 8.27105 71.0935 8.20619C71.139 8.14133 71.1988 8.08917 71.2676 8.05422Z"
                                fill="#27346A"
                              ></path>
                              <path
                                d="M76.3551 8.64593C75.8595 11.3435 74.1627 12.2765 71.9957 12.2765H70.8923C70.6275 12.2765 70.404 12.4808 70.3628 12.7578L69.6376 17.6295C69.6105 17.8111 69.743 17.9756 69.9163 17.9756H71.8732C71.9853 17.9756 72.0937 17.9332 72.1789 17.856C72.2641 17.7789 72.3205 17.672 72.3381 17.5547L72.3571 17.4491L72.7259 14.9723L72.7497 14.8355C72.7672 14.7182 72.8236 14.6113 72.9089 14.5342C72.9941 14.457 73.1025 14.4146 73.2145 14.4146H73.5074C75.403 14.4146 76.8873 13.5986 77.321 11.2386C77.502 10.2523 77.4084 9.42891 76.9294 8.85055C76.7842 8.67537 76.6038 8.53069 76.3936 8.4126C76.3822 8.48886 76.3699 8.56614 76.3551 8.64593Z"
                                fill="#2790C3"
                              ></path>
                              <path
                                d="M75.8736 8.19308C75.7963 8.16917 75.7183 8.148 75.6397 8.1296C75.5573 8.11043 75.4745 8.09375 75.3913 8.07959C75.0935 8.02851 74.7681 8.0044 74.4187 8.0044H71.4713C71.401 8.00423 71.3315 8.02096 71.2681 8.05335C71.1992 8.0882 71.1394 8.14032 71.0938 8.2052C71.0482 8.27008 71.0182 8.34576 71.0064 8.42569L70.3799 12.6347L70.3618 12.7574C70.403 12.4804 70.6266 12.2762 70.8913 12.2762H71.9947C74.1617 12.2762 75.8585 11.3435 76.3542 8.64556C76.3689 8.56576 76.3813 8.48844 76.3927 8.41223C76.2672 8.34202 76.1313 8.28135 75.985 8.22993C75.9481 8.21696 75.9109 8.20468 75.8736 8.19308"
                                fill="#1F264F"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_1_20701">
                                <rect
                                  width="18.0122"
                                  height="11.5793"
                                  fill="white"
                                  transform="translate(33.7009 5.12109)"
                                ></rect>
                              </clipPath>
                              <clipPath id="clip1_1_20701">
                                <rect
                                  width="10.2927"
                                  height="12.8658"
                                  fill="white"
                                  transform="translate(67.1511 5.12109)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__group">
                      <label className="form__label">Expiry Date</label>
                      <div className="form__groupField">
                        <CardExpiryElement className="form__input" />
                      </div>
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__group">
                      <label className="form__label"> CVC</label>
                      <div className="form__groupField">
                        <CardCvcElement className="form__input" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {!isFromBuyAdditionalAssistant ? (
              <div className="paymentWrap__footer">
                {/* <p className="para">
                After completing these steps, you will gain{" "}
                <a className="link link__primary">20 credits</a> for free! You
                will be charged if you are left with 0 credits, unless you
                cancel before your upcoming billing date. The charge will happen
                on the day when your free credits will be expired within two
                hours or less of the same time.
              </p> */}
                <h4 className="price">
                  ${plan?.price}
                  {!plan?.isExpiry || isTopUpPlan
                    ? ""
                    : plan?.interval === "month" ||
                      parseInt(plan?.interval) == 30
                    ? " / Month"
                    : plan?.interval === "year" ||
                      parseInt(plan?.interval) == 365
                    ? " / Year"
                    : ` / ${plan?.interval} Days`}
                  {/*  <a className="link link__primary">Details</a> */}
                </h4>
              </div>
            ) : null}
          </div>
          <div className="paymentWrap__item">
            <div className="paymentWrap__body">
              <div className="form__group">
                <div className="formRow">
                  {isFromBuyAdditionalAssistant ? (
                    <div className="formCol">
                      <div className="form__group">
                        <label className="form__label">No. of Assistants</label>
                        <div className="form__groupField">
                          <input
                            type="text"
                            className="form__input form__input--sm"
                            placeholder="Enter No. of Assistants"
                            value={additionalAssistantData.noOfAssistant}
                            onChange={handleChangeNoOfAssistant}
                          />
                        </div>
                        {additionalAssistantDataError.noOfAssistant ? (
                          <div
                            className="form__error"
                            style={{ marginBottom: "0.75rem" }}
                          >
                            {additionalAssistantDataError.noOfAssistant}
                          </div>
                        ) : null}
                        <p className="form__label">
                          Max Limit - {additionalAssistantData.maxNoOfAssistant}
                        </p>
                        <h4 className="price">
                          $
                          {Number(additionalAssistantData.perAssistantPrice) *
                            Number(additionalAssistantData.noOfAssistant)}{" "}
                          {/* <a className="link link__primary" href="#">
                            Details
                          </a> */}
                        </h4>
                      </div>
                    </div>
                  ) : (
                    <div className="formCol">
                      <div className="form__group">
                        <label className="form__label">
                          Number of Credits you want to purchase
                        </label>
                        <div className="form__groupField">
                          <input
                            type="text"
                            disabled={
                              plan?.price != 1 && plan?.numberOfCredits != 1
                            }
                            className="form__input form__input--sm"
                            placeholder="Enter Credit Count"
                            value={plan?.numberOfCredits}
                            // handleChange={handleCreditsChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!isFromBuyAdditionalAssistant ? (
                <div className="form__group">
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__group">
                        <label className="form__label">Subscription Type</label>
                        <div className="form__radio">
                          {(plan.interval === "month" ||
                            parseInt(plan.interval) == 30) &&
                          !isTopUpPlan ? (
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                id="month"
                                className="form__radio__input"
                                value={plan.interval}
                                disabled={true}
                                name="paymentMode"
                                checked={
                                  plan.interval === "month" ||
                                  parseInt(plan.interval) == 30
                                }
                                // onChange={handleChange}
                              />
                              <label
                                className="form__radio__label"
                                for="PayMonthly"
                              >
                                Pay Monthly
                                <span>${plan?.price}</span>
                              </label>
                            </div>
                          ) : (plan.interval === "year" ||
                              parseInt(plan.interval) == 365) &&
                            !isTopUpPlan ? (
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                value={plan.interval}
                                id="year"
                                name="paymentMode"
                                disabled={true}
                                checked={
                                  plan.interval === "year" ||
                                  parseInt(plan.interval) == 365
                                }
                                // onChange={handleChange}
                                className="form__radio__input"
                              />
                              <label
                                className="form__radio__label"
                                for="PayAnnually"
                              >
                                Pay Annually
                                <span>
                                  $
                                  {plan?.interval === "year" ||
                                  parseInt(plan.interval) == 365
                                    ? plan?.price
                                    : plan?.price * 12}
                                </span>
                              </label>
                            </div>
                          ) : plan?.isExpiry != true || isTopUpPlan ? (
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                value={plan.interval}
                                id="year"
                                name="paymentMode"
                                disabled={true}
                                checked={plan.isExpiry != true}
                                className="form__radio__input"
                              />
                              <label
                                className="form__radio__label"
                                for="PayAnnually"
                              >
                                Pay One Time
                                <span>${plan?.price}</span>
                              </label>
                            </div>
                          ) : (
                            <div className="form__radio__option">
                              <input
                                type="radio"
                                value={plan.interval}
                                id="year"
                                name="paymentMode"
                                disabled
                                checked
                                // onChange={handleChange}
                                className="form__radio__input"
                              />
                              <label
                                className="form__radio__label"
                                for="PayAnnually"
                              >
                                Pay Every {plan?.interval} Days
                                <span>${plan?.price}</span>
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="paymentWrap__footer">
              <p className="para">
                By Continuing you agree to our{" "}
                <a
                  href={TERMS_AND_CONDITIONS_URL}
                  target="_blank"
                  className="link link__primary"
                >
                  Terms and Conditions.
                </a>
              </p>
              <button
                className="btn btn__primary btn--full"
                disabled={
                  isFromBuyAdditionalAssistant
                    ? !additionalAssistantData.noOfAssistant
                    : false
                }
                onClick={handleSubmit}
              >
                Pay
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* </Elements> */}
    </div>
  );
};
